import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { BehaviorSubject } from 'rxjs';
import { ErrorReportingService } from '../../../services/errorReporting/error-reporting.service';
import { BaseComponent } from 'src/app/base/base.component';
import { MatDialog } from '@angular/material/dialog';
import { ErrorReport } from 'src/app/services/errorReporting/errorReport';
import { NavigationService } from '../../../services/navigation/navigation.service';
import { Router } from '@angular/router';

export class PageChangedEventData {
  totalRows: number;
  pageIndex: number;
  rowsPerPage: number;

  constructor(totalRows: number, pageIndex: number, rowsPerPage: number) {
    this.totalRows = totalRows;
    this.pageIndex = pageIndex;
    this.rowsPerPage = rowsPerPage;
  }
}

export class ViewModel {
  errorReport: ErrorReport;
  createdDateTime: string;
  errorMessageTruncated: string;
  applicationName: string;
  errorReportId: number;

  constructor(errorReport: ErrorReport) {
    this.errorReport = errorReport;
    this.createdDateTime = errorReport.createdDateTime.toLocaleString();
    this.errorMessageTruncated = errorReport.errorMessage.substring(0, 200);
    this.applicationName = this.getAppName(errorReport.applicationId);
    this.errorReportId = errorReport.id;
  }

  getAppName(appId: number): string {
    switch (appId) {
      case 1: return 'DataTransformer Python Engine';
      case 2: return 'DataTransformer .NET Web API';
      case 3: return 'DataTransformer Web App';
      default: return 'Unknown';
    }
  }
}

@Component({
    selector: 'app-error-log',
    templateUrl: './error-log.component.html',
    styleUrls: ['./error-log.component.css'],
    standalone: false
})
export class ErrorLogComponent extends BaseComponent implements OnInit {
  @ViewChild('topPaginator') topPaginator: MatPaginator;
  @ViewChild('bottomPaginator') bottomPaginator: MatPaginator;
  @Output() pageChanged = new EventEmitter<PageChangedEventData>();

  noDataTitle = 'No Errors Found';
  dataSource: MatTableDataSource<any>;
  columnsToDisplay = ['id', 'createdDateTime', 'applicationId', 'errorMessage'];
  isGettingData = new BehaviorSubject(false);
  maxRows?: number;
  totalRows = 1000;
  rowsPerPage = 10;
  pageIndex = 0;
  pageSizeOptions = [5, 10, 25, 50, 100];

  constructor(
    private router: Router,
    private navService: NavigationService,
    errorLogger: ErrorReportingService,
    matDialog: MatDialog) {

    super(errorLogger, matDialog);
  }

  async ngOnInit(): Promise<void> {
    const response = await this.errorLogger.getAllErrors(this.pageIndex, this.rowsPerPage);
    await this.bindData(response.errors, response.totalErrors);
  }

  showErrorDetail(viewModel: ViewModel): void {
    this.navService.openSideDrawer();
    this.router.navigate(['./', { outlets: {sidebar: 'errorReportDetailView'}}], {state: {viewModel}});
  }

  async bindData(data: ErrorReport[], totalErrors: number): Promise<void> {
    try {
      this.dataSource = data.length === 0 ? null : new MatTableDataSource<any>();
      if (this.dataSource) {
        this.dataSource.data = Object.values(data.map( r => new ViewModel(r)));
      }
      this.totalRows = totalErrors;
    } catch (err) {
      this.displayError('Failed to fetch error reports.', 'Error', err);
    }
  }

  async onPageChanged(event: PageEvent, sender: MatPaginator): Promise<void> {
    this.totalRows = event.length;
    this.rowsPerPage = event.pageSize;
    this.pageIndex = event.pageIndex;

    if (sender === this.topPaginator) {
      this.bottomPaginator.pageIndex = this.pageIndex;
    } else {
      this.topPaginator.pageIndex = this.pageIndex;
    }

    const busyDialog = this.showBusyDialog('Please wait...');
    try {
      const response = await this.errorLogger.getAllErrors(this.pageIndex, this.rowsPerPage);
      await this.bindData(response.errors, response.totalErrors);
    } finally {
      busyDialog.close();
    }
  }
  goBack():void{
    this.navService.back();
  }
}
